import { useAuth } from '@suntex.fim/auth/react';
import { EntityLevel } from '@suntex.fim/enums';

import { EntityProvider } from '../context/EntityContext';
import { useSwitchEntity } from '../useSwitchEntity';

import { CommonLayout, type CommonLayoutProps } from './CommonLayout';

export type AdminLayoutProps = Pick<CommonLayoutProps, 'appVersion'>;

/**
 * Layout wrapper for admin routes. Also mounts `/my-account` for every role,
 * so it provides an `EntityProvider` from the authed user's own entity so
 * `CommonLayout`'s `EntitySwitcher` doesn't throw for non-admin users.
 */
export function AdminLayout(props: Readonly<AdminLayoutProps>) {
  const { login: user } = useAuth();
  const switchEntity = useSwitchEntity();
  return (
    <EntityProvider
      entityLevel={user?.entityLevel ?? EntityLevel.None}
      entityId={user?.entityId}
      switchEntity={switchEntity}
    >
      <CommonLayout {...props} />
    </EntityProvider>
  );
}
